import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as styles from "/src/components/Project/SlideshowCard.module.css";

const SlideshowCard = (props) => {
  const { title, category, summary, images } = props.data;
  return (
    <div>
      <div className={styles.projectSummaryContainer}>
        <GatsbyImage
          className={styles.slideshowimage}
          image={getImage(images[0].gatsbyImageData)}
          alt={images[0].description}
        />

        <div className={styles.projectData}>
          <div className={styles.projectTitle}>{title}</div>

          <div className={styles.projectCategory}>{category}</div>

          <div className={styles.projectSummary}>{summary}</div>
        </div>
      </div>
    </div>
  );
};

export default SlideshowCard;
